import { render } from "./cTAButton.vue?vue&type=template&id=769ea5ec"
import script from "./cTAButton.vue?vue&type=script&lang=js"
export * from "./cTAButton.vue?vue&type=script&lang=js"

import "./cTAButton.vue?vue&type=style&index=0&id=769ea5ec&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__